
import { useState } from "react"
import { Light as SyntaxHighlighter } from "react-syntax-highlighter"
import js from "react-syntax-highlighter/dist/esm/languages/hljs/javascript"
import java from "react-syntax-highlighter/dist/esm/languages/hljs/java"
import python from "react-syntax-highlighter/dist/esm/languages/hljs/python"
import php from "react-syntax-highlighter/dist/esm/languages/hljs/php"
import ruby from "react-syntax-highlighter/dist/esm/languages/hljs/ruby"
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs"

SyntaxHighlighter.registerLanguage("javascript", js)
SyntaxHighlighter.registerLanguage("java", java)
SyntaxHighlighter.registerLanguage("python", python)
SyntaxHighlighter.registerLanguage("php", php)
SyntaxHighlighter.registerLanguage("ruby", ruby)

const codeExamples = {
  javascript: `// Send a WhatsApp message using JavaScript
const axios = require('axios');

async function sendMessage() {
  try {
    const response = await axios.post('https://gateway.lipachat.com/api/v1/whatsapp/message/text', {
    message: "Hello world",
    messageId: "e66fc7b8-680f-4887-8dc8-ee062d65b54f",
    to: "254XXXXXXXXX",
    from: "BUSINESS_PHONE_NUMBER"
  },{
      headers: {
        'Content-Type: application/json'
        'apiKey': 'YOUR_API_KEY'
      }
    });
    console.log('Message sent:', response.data);
  } catch (error) {
    console.error('Error:', error);
  }
}`,
  python: `# Send a WhatsApp message using Python
import requests

def send_message():
    url = "https://gateway.lipachat.com/api/v1/whatsapp/message/text"
    headers = {
        'Content-Type: application/json'
        'apiKey': 'YOUR_API_KEY'
    }
    data = {
        "message": "Hello world",
        "messageId": "e66fc7b8-680f-4887-8dc8-ee062d65b54f",
        "to": "254XXXXXXXXX",
        "from": "BUSINESS_PHONE_NUMBER"
    }
  response = requests.post(url, json=data, headers=headers)
    print("Message sent:", response.json())`,
  java: `// Send a WhatsApp message using Java
import org.json.JSONObject;
import java.net.http.HttpClient;
import java.net.http.HttpRequest;
import java.net.http.HttpResponse;

public class WhatsAppMessenger {
    public void sendMessage() {
        var client = HttpClient.newHttpClient();
        var json = new JSONObject()
            .put("message", "Hello world")
            .put("messageId", "e66fc7b8-680f-4887-8dc8-ee062d65b54f")
            .put("to", "254XXXXXXXXX");
            .put("from", "BUSINESS_PHONE_NUMBER");

        var request = HttpRequest.newBuilder()
            .uri(URI.create("https://gateway.lipachat.com/api/v1/whatsapp/message/text"))
            .header("apiKey", "YOUR_API_KEY")
            .POST(HttpRequest.BodyPublishers.ofString(json.toString()))
            .build();

        var response = client.send(request, HttpResponse.BodyHandlers.ofString());
        System.out.println("Message sent: " + response.body());
    }
}`,
  php: `<?php
// Send a WhatsApp message using PHP
$curl = curl_init();

curl_setopt_array($curl, [
    CURLOPT_URL => "https://gateway.lipachat.com/api/v1/whatsapp/message/text",
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_CUSTOMREQUEST => "POST",
    CURLOPT_POSTFIELDS => json_encode([
        "message" => "Hello world",
        "messageId" => "e66fc7b8-680f-4887-8dc8-ee062d65b54f",
        "to" => "254XXXXXXXXX",
        "from" => "BUSINESS_PHONE_NUMBER"
    ]),
    CURLOPT_HTTPHEADER => [
        "apiKey": "YOUR_API_KEY",
        "Content-Type: application/json"
    ],
]);

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
    echo "Error: " . $err;
} else {
    echo "Message sent: " . $response;
}`,
  ruby: `# Send a WhatsApp message using Ruby
require 'uri'
require 'net/http'
require 'json'

def send_message
  uri = URI('https://gateway.lipachat.com/api/v1/whatsapp/message/text')
  http = Net::HTTP.new(uri.host, uri.port)
  http.use_ssl = true

  request = Net::HTTP::Post.new(uri)
  request['apiKey'] = 'YOUR_API_KEY'
  request['Content-Type'] = 'application/json'
  request.body = {
    message: "Hello world",
    messageId: "e66fc7b8-680f-4887-8dc8-ee062d65b54f",
    to: "254XXXXXXXXX",
    from: "BUSINESS_PHONE_NUMBER"
  }.to_json

  response = http.request(request)
  puts "Message sent: #{response.body}"
end`
}

const languages = {
  javascript: "JavaScript",
  python: "Python",
  java: "Java",
  php: "PHP",
  ruby: "Ruby"
}

const CodeBlock = () => {
  const [language, setLanguage] = useState("javascript")

  return (
    <div className="space-y-4">
      <div className="flex space-x-1 overflow-x-auto">
        {Object.entries(languages).map(([key, label]) => (
          <button
            key={key}
            onClick={() => setLanguage(key)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              language === key
                ? "bg-gray-400 text-white"
                : "bg-black text-white hover:bg-gray-500/80"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="rounded-lg overflow-hidden">
        <SyntaxHighlighter
          language={language}
          style={atomOneDark}
          customStyle={{
            padding: "1.5rem",
            borderRadius: "0.5rem",
            fontSize: "0.875rem",
          }}
        >
          {codeExamples[language]}
        </SyntaxHighlighter>
      </div>
    </div>
  )
}

export default CodeBlock